import {
  BOOT_APP,
  BOOT_APP_SUCCESS,
  BOOT_APP_FAILURE,
} from './actionTypes';

export default function reducer(state = false, action) {
  switch (action.type) {
    case BOOT_APP_SUCCESS:
    case BOOT_APP_FAILURE:
      return true;
    default:
      return state;
  }
}

// actions
export function bootApp(carrierId) {
  return {
    type: BOOT_APP,
    carrierId,
  };
}

export function setBootCompleteSuccess() {
  return {
    type: BOOT_APP_SUCCESS,
  };
}

export function setBootCompleteFailure() {
  return {
    type: BOOT_APP_FAILURE,
  };
}
